import React from 'react';
import { observer } from 'mobx-react';
import { action, observable } from 'mobx';
import { withRouter, Route, Redirect } from 'react-router-dom';

// import InformationCategory from './InformationCategory';
// import InformationCategoryList from './InformationCategoryList';

import List from './List';
import Edit from './Edit';

import { Tags } from 'root/admin/components';

import store from 'root/admin/store';
import { Loader, TabMenu, MenuItem } from '@smartplatform/ui';

@withRouter
@observer
export default class Articles extends React.Component {
	@observable tab;

	menuItems = [
		{
			label: this.props.type.label,
			id: this.props.type.id,
		},
		{
			label: 'Категории',
			id: 'tags',
		},
	];

	switchTab = record => {
		this.tab = record.id;
		const {
			type: { id: type },
		} = this.props;
		store.history.push(`/admin/${type}/${record.id}`);
		store.ui.setPage(record.id);
	};

	render() {
		let {
			menuItems,
			props: { type },
		} = this;

		const rootPath = `/admin/${type.id}`;
		const path = `${rootPath}/${type.id}`;

		if (store.route.path === rootPath) {
			return <Redirect to={path} />;
		}
		return (
			<div>
				{type.id === 'news' && (
					<TabMenu>
						{menuItems.map(record => (
							<MenuItem
								key={`category-${record.id}`}
								label={record.label}
								onClick={() => this.switchTab(record)}
								active={store.ui.page === record.id}
							/>
						))}
					</TabMenu>
				)}
				<Route
					exact
					path={path}
					component={() => <List rootPath={rootPath} type={type} tabName={menuItems[0].id} path={path} />}
				/>
				<Route
					exact
					path={`${path}/:id`}
					component={() => <Edit rootPath={rootPath} type={type} tabName={menuItems[0].id} path={path} />}
				/>
				{type.id === 'news' && <Route path={`${rootPath}/tags`} component={() => <Tags model="article" />} />}
			</div>
		);
	}
}
